import React from 'react';
import { Link } from 'react-router-dom';

interface ActivationActionsProps {
    row: any;
    galleryUrl: string | null;
}

export default function GalleryActions({
    row,
    galleryUrl,
}: ActivationActionsProps) {
    const galleryId = row.original.id;
    const gallerySlug = row.original.slug;
    return (
        <span className="Table-options">
            <Link to={`gallery/${galleryId}/edit`}>
                <i className="bi bi-pencil-fill"></i>
            </Link>
            <Link to={`gallery/${galleryId}/edit/crowdGallery`}>
                <i className="bi bi-chat-left-text"></i>
            </Link>
            <a
                href={`${galleryUrl}/gallery/${
                    gallerySlug ? encodeURIComponent(gallerySlug) : galleryId
                }`}
                target="_new"
            >
                <i className="bi bi-box-arrow-up-right"></i>
            </a>
        </span>
    );
}
